<nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img src="/assets/images/logo.png" height="35" />
    </a>
    <button class="navbar-toggler" type="button"
            (click)="isMenuCollapsed = !isMenuCollapsed"
            aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse" #menuCollapse="ngbCollapse" [(ngbCollapse)]="isMenuCollapsed">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      </ul>
      @if (isLoggedIn) {
      <span>
        <app-home-tour></app-home-tour>
      </span>
      <span>
        <a href="https://youtu.be/xiDIl4gWu-E" class="nav-link position-relative overflow-hidden" target="_blank">
          <i class="fa-brands fa-youtube"></i> Tutorial
          <span class="new-video-badge bg-success">
            New
          </span>
        </a>
      </span>
      <span>
        <button type="button" class="btn btn-link" (click)="openUserSettingsModal()"><i class="fa-solid fa-gear"></i></button>

      </span>
      <ul class="navbar-nav">
        <li ngbDropdown #userMenu="ngbDropdown" class="nav-item" display="dynamic">
          <a ngbDropdownToggle class="nav-link px-3" role="button" aria-expanded="false">
            <i class="fa-solid fa-user fs-5"></i>
          </a>
          <div ngbDropdownMenu class="w-230px">
            <p class="px-3 py-1 fw-bold">Welcome {{firstName}}</p>
            <a ngbDropdownItem class="dropdown-item" routerLink="profile"><i class="fa-solid fa-user-pen me-2"></i>Manage Profile</a>
            <hr class="dropdown-divider">
            <a ngbDropdownItem class="dropdown-item" href="" (click)="logout()"><i class="fa-solid fa-right-from-bracket me-2"></i>Logout</a>
          </div>

        </li>
      </ul>

      }
    </div>
  </div>
</nav>

<div class="container-fluid flex-grow-1 p-0">
  <router-outlet />
</div>

<!--<div class="bg-black p-5 text-center">
  GT Pro Tune &copy;Copyright 2024
</div>-->
